import { createTheme } from '@mui/material/styles';

export const createAppTheme = (mode = 'light') => createTheme({
  palette: {
    mode,
    primary: {
      light: '#5e6ad5',
      main: '#3f51b5',
      dark: '#2c387e',
      contrastText: '#ffffff',
    },
    secondary: {
      light: '#33c9dc',
      main: '#00b0cc',
      dark: '#007c91',
      contrastText: '#ffffff',
    },
    background: mode === 'light' ? {
      default: '#f7f9fc',
      paper: '#ffffff',
    } : {
      default: '#0b1020',
      paper: '#121a2b',
    },
    text: mode === 'light' ? {
      primary: '#1e293b',
      secondary: '#475569',
    } : {
      primary: '#e2e8f0',
      secondary: '#94a3b8',
    },
    info: {
      main: '#2196f3',
    },
    success: {
      main: '#4caf50',
    },
    warning: {
      main: '#ff9800',
    },
    error: {
      main: '#f44336',
    }
  },
  typography: {
    fontFamily: [
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h3: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 500,
    },
    h6: {
      fontWeight: 400,
    },
    subtitle1: {
      fontWeight: 500,
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
        elevation1: {
          boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.05)',
        },
        elevation3: {
          boxShadow: '0px 4px 12px rgba(63, 81, 181, 0.12)',
        }
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          fontWeight: 500,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontWeight: 500,
          fontSize: '0.95rem',
          textTransform: 'none',
          minHeight: 48,
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          '&:before': {
            display: 'none',
          },
          boxShadow: 'none',
          borderRadius: 6,
          border: '1px solid #e0e0e0',
          marginBottom: 8,
          '&.Mui-expanded': {
            margin: '0 0 8px 0',
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          backgroundColor: mode === 'light' ? '#f0f4ff' : 'rgba(63,81,181,0.12)',
          '&.Mui-expanded': {
            minHeight: 48,
          },
        },
        content: {
          '&.Mui-expanded': {
            margin: '12px 0',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 600,
          backgroundColor: mode === 'light' ? '#eef2ff' : 'rgba(238,242,255,0.08)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 6,
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
  },
  shape: {
    borderRadius: 10,
  },
});

const theme = createAppTheme('light');
export default theme;